import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UserTypeRoutes } from './user-type.routing';
import { UserTypeListComponent } from './list/user-type-list.component';
import { UserTypeAddOrEditComponent } from './add-or-edit/user-type-add-or-edit.component';
import { AppService, UserTypeFeatureService, UserTypeService, UserTypeStatusService } from '@ov-suite/services-angular';
import { UiModule } from '@ov-suite/ui';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(UserTypeRoutes),
    FormsModule,
    UiModule
  ],
  declarations: [UserTypeListComponent, UserTypeAddOrEditComponent],
  providers: [
    UserTypeService,
    UserTypeStatusService,
    AppService,
    UserTypeFeatureService
  ]
})
export class UserTypeModule {}

// import { NgModule } from '@angular/core';
// import { OvGenericModule } from '@ov-suite/ui';
// import { UserType } from "@ov-suite/adminlink-models";
//
// @NgModule({
//   imports: [
//     OvGenericModule.forRoot({
//       entity: UserType,
//       api: 'idmlink',
//       createTitle: 'User Type',
//       route: ['management/user-type'],
//       tableTitle: 'User Types',
//       tabs: [
//         {
//           title: 'Users',
//           path: '/management/users'
//         },
//         {
//           title: 'User Types',
//           path: '/management/user-type'
//         }
//       ]
//     })
//   ]
// })
// export class UserTypeModule {}
